export default {
    data() {
        return {
            maxTabHeight: '100px'
        }
    },
    mounted() {
        let tabc = this.$refs?.tableContent
        let clientHeight = tabc ? tabc.clientHeight : 150
        let maxHeight = `${clientHeight - 150}px`
        this.maxTabHeight = maxHeight
    }
}